import React, { useContext, useState, useEffect } from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import AC_GRID from '../../AutocodeTypes';
import ACDictionaryContext from '../../ACContext/ACDictionaryContext';
import { useACSelectionBoxContext } from '../../ACContext/ACSelectionBoxContext';
import AutocodeSelectionAction from '../../AutocodeSelectionBox/AutocodeSelectionActions';
import AutocodeCheckBox from '../../ACShared/AutocodeCheckBox';
import { AC_ROOT_NODE_ID, AC_OPERATORS } from '../../AutocodeConstants';
import GenericButton from '../../../common/GenericButton';
import ACTemplateRow from './ACTemplateRow';
import AutocodeCustomDragLayer from '../../AutocodeCustomDragLayer';
import { getDatapointsForTemplate278 } from '../../../../util/AutocodeDragAndDropUtils';

const ACTemplate8 = () => {
  const { selectedNodeAnswers, disableAddButton } = useContext(
    ACDictionaryContext
  );
  const acSelContext = useACSelectionBoxContext();
  const {
    insertLeafNode,
    insertOperatorNode,
    insertOperatorNetAnyNode,
    insertNetanyLeafNode,
  } = AutocodeSelectionAction(acSelContext.state, acSelContext.dispatch);
  const [allSelectedAns, setAllSelectedAns] = useState(false);
  const [allSelectedChild, setallSelectedChild] = useState(false);
  const [selectedNode, setSelectedNode] = useState([]);
  const [child, setChild] = useState([]);
  const [disableCheck, setDisableCheck] = useState(false);
  const [addButtonDisabled, setaddButtonDisabled] = useState(true);
  const [or, setOr] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  const selectOr = () => setOr(!or);

  const selectedCheckedData = () => {
    const check = selectedNode.filter(res => res.checked === true);
    const checkChild = child.filter(res => res.checked === true);

    if (check.length > 0 && checkChild.length > 0) {
      setaddButtonDisabled(false);
    } else {
      setaddButtonDisabled(true);
    }
    const allCheck = selectedNode.every(a => a.checked === true);
    setAllSelectedAns(allCheck);
    const allCheckchild = child.every(a => a.checked === true);
    setallSelectedChild(allCheckchild);
    const multipleChild = child.filter(a => a.checked);
    if (multipleChild.length > 1) {
      setDisableCheck(false);
      if (check.length > 0) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
        if (or) {
          selectOr();
        }
      }
    } else if (multipleChild.length <= 1) {
      setOr(false);
      setIsDisabled(true);
    }
  };

  useEffect(() => {
    selectedCheckedData();
  }, [child, selectedNode]);

  useEffect(() => {
    setSelectedNode(() => {
      if (
        selectedNodeAnswers &&
        selectedNodeAnswers.root &&
        selectedNodeAnswers.root.children &&
        selectedNodeAnswers.root.children.length > 0
      )
        return selectedNodeAnswers.root.children.map(a => {
          a.children = a.children.map(res => ({ ...res, checked: false }));
          return { ...a, checked: false };
        });
      return [];
    });
    setChild(() => {
      const childData = selectedNodeAnswers.root.children[0].children;
      if (childData.length === 0) return [];
      return childData.map(a => ({ ...a, checked: false }));
    });
  }, [selectedNodeAnswers]);

  const addNode = (ans, selectedNode, isChecked) => {
    setSelectedNode(
      selectedNode.map(a => {
        a = a.node === ans.node ? { ...a, checked: isChecked } : { ...a };
        return a;
      })
    );
  };

  const ansSelect = (isChecked, ans, event) => {
    let checkedItems = [];
    checkedItems = selectedNode.filter(i => i.checked);
 
    // check single item if shift key is not pressed or item is being unchecked
    // ...or shift key is pressed and no other items checked
    if (
      !event ||
      !event.nativeEvent.shiftKey ||
      (event && event.nativeEvent.shiftKey && checkedItems.length === 0) || !isChecked
    ) {
      addNode(ans, selectedNode, isChecked);
      return;
    }
    // find range of items between last checked item and item being checked
    
    let lastCheckedItem = [];
      lastCheckedItem = checkedItems[checkedItems.length - 1];
    const startIndex = selectedNode.indexOf(lastCheckedItem);
    const endIndex = selectedNode.indexOf(ans);
    let fromIndex = 0;
    let toIndex = 0;
    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
      fromIndex = startIndex;
      toIndex = endIndex;
    } else {
      fromIndex = endIndex;
      toIndex = startIndex;
    }
 
    // check all those items in range
    let itemsInRange = [];
    itemsInRange = selectedNode.slice(fromIndex, toIndex + 1);
    setSelectedNode([
      ...selectedNode.slice(0, fromIndex),
      ...itemsInRange.map(a => ({ ...a, checked: isChecked })),
      ...selectedNode.slice(toIndex + 1),
    ]);
  };

  const handleSelectAllAnswer = isChecked => {
    setSelectedNode(selectedNode.map(a => ({ ...a, checked: isChecked })));
    setAllSelectedAns(isChecked);
  };

  const addChildren = (child, selectedChildren, isChecked) => {
    setChild(
      child.map(a =>
        a.shortText === selectedChildren.shortText
          ? { ...a, checked: isChecked }
          : { ...a }
      )
    );
  };

  const childrenSelected = (isChecked, selectedChildren, event) => {
    let checkedItems = [];
    checkedItems = child.filter(i => i.checked);
 
    // check single item if shift key is not pressed or item is being unchecked
    // ...or shift key is pressed and no other items checked
    if (
      !event ||
      !event.nativeEvent.shiftKey ||
      (event && event.nativeEvent.shiftKey && checkedItems.length === 0) || !isChecked
    ) {
      addChildren(child, selectedChildren, isChecked);
      return;
    }
    // find range of items between last checked item and item being checked
    
    let lastCheckedItem = [];
      lastCheckedItem = checkedItems[checkedItems.length - 1];
    const startIndex = child.indexOf(lastCheckedItem);
    const endIndex = child.indexOf(selectedChildren);
    let fromIndex = 0;
    let toIndex = 0;
    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
      fromIndex = startIndex;
      toIndex = endIndex;
    } else {
      fromIndex = endIndex;
      toIndex = startIndex;
    }
 
    // check all those items in range
    let itemsInRange = [];
    itemsInRange = child.slice(fromIndex, toIndex + 1);
    setChild([
      ...child.slice(0, fromIndex),
      ...itemsInRange.map(a => ({ ...a, checked: isChecked })),
      ...child.slice(toIndex + 1),
    ]);
  };

  const handleSelectAllChild = isChecked => {
    setChild(child.map(a => ({ ...a, checked: isChecked })));
    setallSelectedChild(isChecked);
  };

  const addToSelectionBox = () => {
    // Setting final datapoints data from AutocodeDragAndDropUtils to add data to selection box
    const selectedAns = getDatapointsForTemplate278(
      child,
      selectedNode,
      selectedNodeAnswers
    );
    // sending data on the basis of OR
    selectedAns.forEach(res => {
      const checkNetAny = res.filter(
        r => _.upperCase(r.keyword.slice(0, 3)) === 'XNA'
      );
      if (or) {
        // if or then check for netany
        if (checkNetAny.length > 1) {
          insertOperatorNetAnyNode('net any', res, AC_ROOT_NODE_ID, -1, {
            operator: AC_OPERATORS.type.or,
          });
        } else {
          insertOperatorNode(
            res,
            AC_OPERATORS.type.or,
            AC_ROOT_NODE_ID,
            true,
            -1
          );
        }
      } else if (checkNetAny.length > 0 && !or) {
        // if net any and single node then NETANY ( DATA )
        insertNetanyLeafNode(
          'net any',
          false,
          false,
          res,
          1,
          AC_ROOT_NODE_ID,
          -1
        );
      } else {
        insertLeafNode(res, AC_ROOT_NODE_ID, -1);
      }
    });
    // reset data after it send to selection box
    setSelectedNode(
      selectedNode.map(a => {
        a.children = a.children.map(res => ({ ...res, checked: false }));
        return { ...a, checked: false };
      })
    );
    setChild(child.map(a => ({ ...a, checked: false })));
    setAllSelectedAns(false);
    setallSelectedChild(false);
    setOr(false);
  };

  const getSelectedEntries = () => {
    const tempChild = child.filter(item => item.checked);
    const tempSelectedNode = selectedNode.filter(item => item.checked);
    const selectedDragableItem = [];
    const childShortText = [];
    tempChild.forEach(res => {
      childShortText.push(res.shortText);
    });
    tempSelectedNode.forEach(item => {
      if (or) {
        const tempObj = {};
        tempObj.shortText = `${item.shortText} (${childShortText.join(
          ' OR '
        )} )`;
        selectedDragableItem.push(tempObj);
      } else {
        childShortText.forEach(res => {
          const tempObj = {};
          tempObj.shortText = `${item.shortText}_${res}`;
          selectedDragableItem.push(tempObj);
        });
      }
    });
    return selectedDragableItem;
  };

  const resetSelectedRows = () => {
    setSelectedNode(
      selectedNode.map(a => {
        a.children = a.children.map(res => ({ ...res, checked: false }));
        return { ...a, checked: false };
      })
    );
    setChild(child.map(a => ({ ...a, checked: false })));
    setAllSelectedAns(false);
    setallSelectedChild(false);
    setOr(false);
  };

  return (
    <div>
      <div className="ac-dictionary-container-temp2">
        {/* first children */}
        <div
          key={child.uniqueId}
          style={{ height: 'calc(100vh - 600px)', flex: '100%' }}
        >
          <AutocodeCustomDragLayer
            items={getSelectedEntries()}
            type={AC_GRID.AC_TEMPLATE_DOUBLE_LIST}
          />
          <div
            className={classnames('ac-dictionary-row', {
              'ac-dictionary-row-checked': allSelectedChild,
            })}
          >
            <div className="ac-dictionary-row-checkbox">
              <AutocodeCheckBox
                onChange={handleSelectAllChild}
                id={`ct_select_${child.uniqueId}`}
                isChecked={allSelectedChild}
                fill="#94A2B7"
                stroke="#94A2B7"
                allCheck
                label="All"
              />
            </div>
          </div>
          <div className="ac-dictionary-body">
            {child.map(res => (
              <ACTemplateRow
                ACTemplateType={AC_GRID.AC_TEMPLATE_8}
                key={res.keyword}
                onChange={childrenSelected}
                id={`ct_select_${res.keyword}`}
                isChecked={res.checked}
                fill={res.checked ? '#94A2B7' : '#94A2B7'}
                stroke={res.checked ? '#94A2B7' : '#94A2B7'}
                data={res}
                label={res.shortText}
                selectedList1={child}
                selectedList2={selectedNode}
                selectedNodeAnswers={selectedNodeAnswers}
                or={or}
                isDragable={!addButtonDisabled && !disableAddButton}
                resetSelectedRows={resetSelectedRows}
              />
            ))}
          </div>
        </div>

        {/* second Answers */}
        <div style={{ height: 'calc(100vh - 660px)', flex: '100%' }}>
          <div
            className={classnames('ac-dictionary-row ac-borderline', {
              'ac-dictionary-row-checked': allSelectedAns,
            })}
          >
            <div className="ac-dictionary-row-checkbox">
              <AutocodeCheckBox
                onChange={handleSelectAllAnswer}
                id="ct_select_0000"
                isChecked={allSelectedAns}
                fill="#94A2B7"
                stroke="#94A2B7"
                allCheck
                label="All"
              />
            </div>
          </div>
          <div className="ac-dictionary-body">
            {selectedNode.map(a => (
              <ACTemplateRow
                ACTemplateType={AC_GRID.AC_TEMPLATE_8}
                key={a.keyword}
                onChange={ansSelect}
                id={`ct_select_${a.keyword}`}
                isChecked={a.checked}
                fill={a.checked ? '#94A2B7' : '#94A2B7'}
                stroke={a.checked ? '#94A2B7' : '#94A2B7'}
                data={a}
                label={a.shortText}
                selectedList1={child}
                selectedList2={selectedNode}
                selectedNodeAnswers={selectedNodeAnswers}
                or={or}
                isDragable={!addButtonDisabled && !disableAddButton}
                resetSelectedRows={resetSelectedRows}
              />
            ))}
          </div>
        </div>
      </div>
      {/* OR checkbox and add btn */}
      <div
        style={{
          borderTop: '1px solid #e0e0e0',
          padding: '1px 7px',
        }}
      >
        <div className="ac-dictionary-row-checkbox ac-orCheckbox">
          <AutocodeCheckBox
            onChange={selectOr}
            id="ct_select_0000"
            isChecked={or}
            fill={or ? '#fff' : '#94A2B7'}
            stroke={or ? '#7994BB' : '#94A2B7'}
            opacity={or ? '1' : '0.1'}
            label={
              <span className="ac-dictionary-middle__text">
                Combine Response by
                <span className="ac-dictionary-middle__selectall"> OR</span>
              </span>
            }
            disableCheck={disableCheck}
            disable={isDisabled}
          />
        </div>
        <GenericButton
          name="Add"
          btnStyle="ac-dictionary__addbutton"
          btnDisabled={addButtonDisabled || disableAddButton}
          onBtnClick={addToSelectionBox}
        />
      </div>
    </div>
  );
};

export default ACTemplate8;
